import ContentBoxText from './ContentBoxText';

export default ContentBoxText;
